import cn from 'classnames'

import * as s from './DemoWrapper.module.scss'

interface IProps {
  children?: React.ReactNode
  center?: boolean
  full?: boolean
}

const DemoWrapper: React.FC<IProps> = ({ children, center, full }) => {
  return <div className={cn({ [s.center]: center, [s.full]: full })}>{children}</div>
}

export default DemoWrapper
